import script from "./commission-transfer.vue?vue&type=script&setup=true&lang=js"
export * from "./commission-transfer.vue?vue&type=script&setup=true&lang=js"

import "./commission-transfer.vue?vue&type=style&index=0&id=5a2e1e63&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/builds/jolly88-complex/frontend/affiliate-static-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a2e1e63"]])

export default __exports__